import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';
import { queryKeys, type ResponseBody } from '../react-query.config';
import { toast } from 'sonner';
import { useNavigate } from '@tanstack/react-router';

type DuplicatePickemResponse = ResponseBody<'/api/admin/pickems/{id}/duplicate', 'post'>;

interface DuplicatePickemParams {
  pickemId: string;
  league_id: string;
}

export const duplicatePickem = ({ pickemId, league_id }: DuplicatePickemParams) =>
  apiClient.post(
    '/api/admin/pickems/{id}/duplicate',
    { league_id },
    { pathParams: { id: pickemId } }
  );

export const useDuplicatePickemMutation = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation<DuplicatePickemResponse, Error, DuplicatePickemParams>({
    mutationFn: duplicatePickem,
    onSuccess: response => {
      queryClient.invalidateQueries({ queryKey: queryKeys.pickems.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.questions.all });
      toast.success('Pickem duplicated successfully! Questions have been copied.');
      navigate({
        to: '/dashboard/pickems/$id',
        params: { id: response.pickem.pickem_id },
        search: { league_id: undefined },
      });
    },
    onError: (error: any) => {
      toast.error(error.message || 'Failed to duplicate pickem');
    },
  });
};
